var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Spinner from "../Spinner/Spinner";
import { classNames } from "../Util";
export var baseButtonStyle = "inline-flex justify-center rounded-md border py-2 px-4 text-sm font-medium shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2";
export var buttonStyles = {};
buttonStyles.primary = {
    bgColor: "bg-blue-600",
    bgColorDisabled: "bg-blue-700",
    bgColorHover: "hover:bg-blue-700",
    colorFocusRing: "focus:ring-blue-500",
    colorText: "text-white",
    colorTextDisabled: "text-gray-400",
    colorBorder: "border-transparent",
};
buttonStyles.secondary = {
    bgColor: "bg-blue-100",
    bgColorDisabled: "bg-blue-200",
    bgColorHover: "hover:bg-blue-200",
    colorFocusRing: "focus:ring-blue-500",
    colorText: "text-blue-700",
    colorTextDisabled: "text-gray-400",
    colorBorder: "border-transparent",
};
buttonStyles.white = {
    bgColor: "bg-white",
    bgColorDisabled: "bg-gray-50",
    bgColorHover: "hover:bg-gray-50",
    colorFocusRing: "focus:ring-blue-500",
    colorText: "text-gray-700",
    colorTextDisabled: "text-gray-300",
    colorBorder: "border-gray-300",
};
buttonStyles.whiteBlueAccent = {
    bgColor: buttonStyles.white.bgColor,
    bgColorDisabled: buttonStyles.white.bgColorDisabled,
    bgColorHover: buttonStyles.white.bgColorHover,
    colorFocusRing: buttonStyles.white.colorFocusRing,
    colorText: "text-blue-700",
    colorTextDisabled: "text-blue-300",
    colorBorder: "border-blue-700",
};
buttonStyles.danger = {
    bgColor: "bg-red-600",
    bgColorDisabled: "bg-red-700",
    bgColorHover: "hover:bg-red-700",
    colorFocusRing: "focus:ring-red-500",
    colorText: "text-white",
    colorTextDisabled: "text-gray-400",
    colorBorder: "border-transparent",
};
buttonStyles.gray = {
    bgColor: "bg-gray-50",
    bgColorDisabled: "bg-gray-50",
    bgColorHover: "hover:bg-gray-100",
    colorFocusRing: "focus:ring-blue-500",
    colorText: "text-gray-700",
    colorTextDisabled: "text-gray-500",
    colorBorder: "border-gray-300",
};
var Button = function (_a) {
    var _b = _a.type, type = _b === void 0 ? "primary" : _b, text = _a.text, _c = _a.fullWidth, fullWidth = _c === void 0 ? false : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.loading, loading = _e === void 0 ? false : _e, onClick = _a.onClick, className = _a.className, icon = _a.icon, htmlType = _a.htmlType, iconOnly = _a.iconOnly;
    // TODO - Spinner color
    var ButtonIcon = icon;
    return (_jsxs("button", __assign({ type: htmlType, disabled: disabled, onClick: onClick, className: classNames(baseButtonStyle, fullWidth ? "w-full" : "", buttonStyles[type].colorBorder, buttonStyles[type].colorText, buttonStyles[type].bgColorHover, buttonStyles[type].colorFocusRing, disabled || loading
            ? "cursor-not-allowed ".concat(buttonStyles[type].bgColorDisabled, " ").concat(buttonStyles[type].colorTextDisabled)
            : buttonStyles[type].bgColor, className ? className : ""), title: iconOnly ? text : undefined }, { children: [loading && _jsx(Spinner, {}), (!loading && ButtonIcon) &&
                _jsx(ButtonIcon, { className: classNames("h-5 w-5 -ml-1", iconOnly ? "-mr-1" : "mr-2 "), "aria-hidden": "true" }), iconOnly ? _jsx(_Fragment, {}) : text] })));
};
export default Button;
